import { c as _c } from "react/compiler-runtime";
import { FaroDatePickerHeader } from "@components/common/faro-text-button-date-picker/faro-date-picker-header";
import { FaroDateTextField } from "@components/common/faro-text-button-date-picker/faro-date-text-field";
import { Overlay } from "@components/overlay/overlay";
import DateAdapter from "@date-io/luxon";
import { NO_TRANSLATE_CLASS, Popover } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { DateCalendar } from "@mui/x-date-pickers-pro";
import { useMemo, useState } from "react";
/** A date picker text and calendar shown in a popover. Needs to be attached to an element */
export function FaroDatePicker(t0) {
  const $ = _c(23);
  const {
    initialDate,
    onDateConfirmed,
    anchorEl,
    closeDatePicker
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new DateAdapter();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const dateAdapter = t1;
  let t2;
  if ($[1] !== initialDate) {
    t2 = initialDate ? dateAdapter.date(initialDate) : null;
    $[1] = initialDate;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [date, setDate] = useState(t2);
  const t3 = Boolean(anchorEl);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      zIndex: 9999
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== closeDatePicker) {
    t5 = event => {
      if (event.key === "Escape") {
        closeDatePicker();
        event.stopPropagation();
      }
    };
    $[4] = closeDatePicker;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = value => setDate(value);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== date || $[8] !== onDateConfirmed) {
    t7 = <FaroDateTextField date={date} onConfirmed={onDateConfirmed} onChange={t6} />;
    $[7] = date;
    $[8] = onDateConfirmed;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      calendarHeader: FaroDatePickerHeader
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== date || $[12] !== onDateConfirmed) {
    t9 = <DateCalendar className={NO_TRANSLATE_CLASS} slots={t8} value={date} onChange={onDateConfirmed} />;
    $[11] = date;
    $[12] = onDateConfirmed;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t5 || $[15] !== t7 || $[16] !== t9) {
    t10 = <Box onKeyDown={t5}>{t7}{t9}</Box>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== anchorEl || $[19] !== closeDatePicker || $[20] !== t10 || $[21] !== t3) {
    t11 = <Overlay><Popover open={t3} anchorEl={anchorEl} placement="bottom-start" onClose={closeDatePicker} showCloseButton={false} sx={t4}>{t10}</Popover></Overlay>;
    $[18] = anchorEl;
    $[19] = closeDatePicker;
    $[20] = t10;
    $[21] = t3;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}